import { Box, Stack } from "@mui/material";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import TitleBar from "../titlebar/TitleBar";

import KlasisLoader from "../../components/KlasisLoader";

export interface IPageContentProps {
    title?: string;
    showBreadcrumbs?: boolean;
    showTitleBarCommands?: boolean;
    children?: JSX.Element | JSX.Element[];
    titleBarRightSideElement?: JSX.Element | JSX.Element[];
    isLoading?: boolean;
}

const PageContent: React.FC<IPageContentProps> = (props: IPageContentProps) => {
    const renderContent = (): JSX.Element => {
        if (props.isLoading) {
            return <KlasisLoader />;
        }

        return (
            <>
                {props.showBreadcrumbs && <Breadcrumbs />}

                <Box
                    style={{
                        padding: "0 1rem 0 1rem",
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                    }}
                >
                    {props.title && (
                        <TitleBar
                            rightSideElement={props.titleBarRightSideElement}
                            title={props.title ?? ""}
                            showCommands={props.showTitleBarCommands}
                        />
                    )}

                    {props.children}
                </Box>
            </>
        );
    };

    return (
        <Stack paddingTop={2} paddingBottom={4} flex={1}>
            {renderContent()}
        </Stack>
    );
};

export default PageContent;
